import React from 'react';
import { ExpandableMenuProps } from 'src/app/molecules/Header/Header/HeaderLinks';
import MegaMenu from 'molecules/Header/MegaMenu/MegaMenuContainer';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import ResourcesMegaMenuFeatures from './ResourcesMegaMenuFeatures';
import ResourcesMegaMenuLearnMore from './ResourcesMegaMenuLearnMore';

const ResourcesMegaMenu = ({ isOpen, onClose }: ExpandableMenuProps): JSX.Element => {
  return (
    <MegaMenu
      isOpen={isOpen}
      onClose={onClose}
    >
      <Stack
        margin={['spacing-none', 'spacing-auto']}
        align='stretch'
        justify='space-between'
        direction='row'
        maxWidth='width-3xl'
        padding={['spacing-none', 'spacing-4xl']}
      >
        <ResourcesMegaMenuFeatures />
        <ResourcesMegaMenuLearnMore />
      </Stack>
    </MegaMenu>
  );
};

export default ResourcesMegaMenu;
